import React, {createRef, useEffect} from 'react';
import DeliveryTimeSelectProperties from "./DeliveryTimeSelectProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import {useCommonContext} from "../../../contexts/CommonContext";
import {useStyles} from "./DeliveryTimeSelect.style";
import clsx from "clsx";
import {useCommonStyles} from "../../../ui_components/common/CommonStyles.style";
import Loading from "../../../ui_components/PageLoading/Loading";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DeliveryTimeStore from "./DeliveryTimeStore";
import {Observer} from "mobx-react-lite";
import ElementRow from "./row/ElementRow";
import CancelIcon from '@mui/icons-material/Cancel';
import {Tooltip} from "@material-ui/core";

const DeliveryTimeSelect: React.FC<DeliveryTimeSelectProperties> = ({
                                                                          onChange,
                                                                          disabled,
                                                                          fullWidth = false,
                                                                          className = '',
                                                                          articleId,
                                                                          selected,
                                                                          showCleanButton = true,
                                                                          initialLoadAmount = 15,
                                                                      }) => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const menuRef = createRef<HTMLDivElement>();
    const inputRef = createRef<HTMLInputElement>();

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const store = new DeliveryTimeStore(commonContext, initialLoadAmount, articleId, selected);
    const containerClasses = clsx(classes.select_container, className, fullWidth && commonClasses.fullWidth);

    useEffect(() => {
        if (selected) {
            store.setSelectedDeliveryTime(selected);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected])

    // useEffect(() => {
    //     store.search();
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // },[store.isSearchDialogOpen])

    useEffect(() => {
        const clickOutside = (event: any) => {
            if (menuRef && !menuRef.current?.contains(event.target)) {
                store.toggleSearchDialog(false);
            }
        }
        document.addEventListener('mousedown', clickOutside);
        return () => {
            document.removeEventListener('mousedown', clickOutside)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [menuRef])

    const toggleDialog = () => {
        store.toggleSearchDialog();
        setTimeout(() => inputRef.current?.focus(), 20);
    }

    const selectDeliveryTime = (deliveryTime: number) => {
        store.setSelectedDeliveryTime(deliveryTime);
        onChange(deliveryTime);
    }

    const removeSelected = (e:React.MouseEvent) => {
        store.setSelectedDeliveryTime(undefined);
        e.stopPropagation();
        onChange(undefined);
    }
    return (
        <Observer>
            {() => (
                <div className={containerClasses} ref={menuRef}>
                    <div className={classes.label}>{i18n.translate("DELIVERY_TIME")}</div>
                    <div className={classes.input_container} onClick={toggleDialog}>
                        <LocalShippingIcon/>
                        <div className={classes.info_container}>
                            {store.selectedDeliveryTime &&
                            <div className={classes.selected_container}>
                                <div className={classes.selected_text_container}>
                                    <div><b>{store.selectedDeliveryTime}</b></div>
                                </div>
                                {showCleanButton && <Tooltip title={i18n.translate("CLEAN")}>
                                    <div onClick={removeSelected} className={classes.remove_icon}><CancelIcon/></div>
                                </Tooltip>}

                            </div>
                            }
                            {store.selectedDeliveryTime === null && <div>Default</div>}
                            {store.selectedDeliveryTime === undefined && <div>No definido</div>}
                        </div>
                        <div className={classes.expand_icon}>
                            {store.isSearchDialogOpen && <ExpandLessIcon/>}
                            {!store.isSearchDialogOpen && <ExpandMoreIcon/>}
                        </div>
                    </div>
                    {store.isSearchDialogOpen &&
                    <div className={classes.options_container}>
                        <div className={classes.options_body}>
                            {store.loading && <Loading className={classes.loading} fontSize={55}/>}
                            {!store.loading && !store.isEmpty && <div className={classes.elements_container}>
                                {store.elements.map((el, i) => (
                                    <ElementRow
                                        key={i}
                                        className={className}
                                        deliveryTime={el}
                                        selected={el === store.selectedDeliveryTime}
                                        onSelect={selectDeliveryTime}
                                    />
                                ))}
                            </div>}
                            {!store.loading && store.isEmpty &&
                            <div className={classes.empty_container}>
                                <div>{i18n.translate("NO_AGENCIES_TITLE")}</div>
                            </div>}
                        </div>
                    </div>
                    }
                </div>
            )}
        </Observer>
    )
}


export default DeliveryTimeSelect;